import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@fontsource-variable/dm-sans/index.css";
import "./index.css";

// Recover from stale lazy-chunk hashes after a redeploy by reloading once.
const RELOAD_KEY = "__chunk_reload_attempted__";
function handleChunkLoadError(message?: string) {
  if (!message) return;
  const isChunkError =
    /Importing a module script failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Loading chunk [\d]+ failed/i.test(message) ||
    /ChunkLoadError/i.test(message);
  if (!isChunkError) return;
  if (sessionStorage.getItem(RELOAD_KEY)) return;
  sessionStorage.setItem(RELOAD_KEY, "1");
  window.location.reload();
}
window.addEventListener("error", (e) => handleChunkLoadError(e?.message));
window.addEventListener("unhandledrejection", (e) =>
  handleChunkLoadError((e?.reason && (e.reason.message || String(e.reason))) || "")
);

createRoot(document.getElementById("root")!).render(<App />);
